/**
 * Created by mathias.gamperl on 14.01.2015.
 */
export default ["$timeout",function ($timeout) {

  return function (callback, interval) {
    var timeout = null;
    //console.log("debounce");
    return function () {
      //console.log("debounce");
      $timeout.cancel(timeout);
      timeout = $timeout(callback, interval);
    };
  };
}];



// WEBPACK FOOTER //
// ./src/ui/app/services/dc-debounce.js